import styled from 'styled-components';
import { font, colors, breakpoints } from '@chegg-ui/theme';
var family = font.family,
  _font$size = font.size,
  px14 = _font$size.px14,
  px12 = _font$size.px12;
var dark = colors.dark;
export var TaxContainer = styled.div.withConfig({
  componentId: "sc-1t7ogpo-0"
})(["font-family:", ";p{font-size:", ";color:", ";@media (max-width:", "){font-size:", ";text-align:center;margin-top:revert;}}"], family.aspira, px14, dark, breakpoints.md.max, px12);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/Tax/styled.js
// module id = 4017
// module chunks = 11